import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme, Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1em 0 2.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1em 0 1.5em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  errorMessage: {
    color: 'red',
    display: 'flex',
    alignItems: 'center',
    margin: '1em 0 0.2em',
    '& svg': {
      marginRight: '0.4em',
    },
  },
}));

interface RoomNameScreenProps {
  name: string;
  lastName: string;
  phonenumber: string;
  contactName: string;
  contactLastName: string;
  contactPhonenumber: string;
  setName: (name: string) => void;
  setLastName: (lastName: string) => void;
  setPhoneNumber: (phonenumber: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

export default function RoomNameScreen({
  name,
  lastName,
  phonenumber,
  contactName,
  contactLastName,
  contactPhonenumber,
  setName,
  setLastName,
  setPhoneNumber,
  handleSubmit,
}: RoomNameScreenProps) {
  const classes = useStyles();
  //const { user } = useAppState();
  const [oldName, setOldName] = useState<string>('');
  const [oldLastName, setOldLastName] = useState<string>('');
  const [oldPhone, setOldPhone] = useState<string>('');

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
    setOldName(event.target.value);
  };

  const handlePhoneNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(event.target.value);
    setOldPhone(event.target.value);
  };

  const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLastName(event.target.value);
    setOldLastName(event.target.value);
  };

  const handleContactDetailsChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setName(contactName);
      setLastName(contactLastName);
      setPhoneNumber(contactPhonenumber);
    } else {
      setName(oldName);
      setLastName(oldLastName);
      setPhoneNumber(oldPhone);
    }
  };

  //const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Patient Details
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          <div className={classes.textFieldContainer}>
            <FormControlLabel
              label="Same as contact details"
              control={
                <Checkbox
                  autoCapitalize="false"
                  id="input-same-as-contact-details"
                  size="small"
                  onChange={handleContactDetailsChange}
                />
              }
            />
          </div>

          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-user-name">
              First Name
            </InputLabel>
            <TextField
              id="input-user-name"
              variant="outlined"
              fullWidth
              size="small"
              value={name}
              onChange={handleNameChange}
            />
          </div>

          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-last-name">
              Last Name
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-last-name"
              variant="outlined"
              fullWidth
              size="small"
              value={lastName}
              onChange={handleLastNameChange}
            />
          </div>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-phone-number">
              Contact Number
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-phone-number"
              variant="outlined"
              fullWidth
              size="small"
              value={phonenumber}
              onChange={handlePhoneNumberChange}
            />
          </div>
        </div>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!name || !lastName || !phonenumber}
            className={classes.continueButton}
          >
            Continue
          </Button>
        </Grid>
      </form>
    </>
  );
}
